skrilla.service('uiUrlsService', function(envService, sportService){
    const getEventBettingUrl =  function(event){
        //http://localhost:8000/en-au/betting/match/266ebd49-7889-4801-b9fc-98b9b074badf
        const eventType = event.eventType;

        if (eventType === 'SEASON' || eventType === 'TOURNAMENT') {
            return  `${envService.read('uiUrl')}/betting/outright/${event.eventId}`
        } else if (eventType === 'MATCH') {
            return  `${envService.read('uiUrl')}/betting/match/${event.eventId}`
        } else if (eventType === 'RACE') {
            return  `${envService.read('uiUrl')}/racing/betting/race/${event.attributes.meetingId}/${event.attributes.raceNumber}/win-place/`
        } else {
            console.error( "Unknown event type " + eventType)
            return null;
        }
    }
    const getSportBettingUrl =  async function (sportCode) {
        const sport = await sportService.getSport(sportCode);
        const bettingPath = sport.bettingPath;
        return `${envService.read('uiUrl')}${bettingPath}`
    }
    const getPickemsContestUrl =  async function (id) {
        return `${envService.read('uiUrl')}/pickems/contest/${id}`
    }

    return {
        getEventBettingUrl,
        getSportBettingUrl,
        getPickemsContestUrl
    };
});

